import { DistrictAPIResponse } from '../types/responses/district-list.responses';

export interface ProFormForm {
  id: number;
  title: string;
  outro: string;
  creator_user_id: number;
  district_id: number;
  is_shared: number;
  anonymity: string;
  status: string;
  type: string;
  show_missed: number;
  show_answers: number;
  passing_grade: number;
}

export interface ProFormListItem extends ProFormForm {
  submissionCount: number;
  district: DistrictAPIResponse;
}

// ADMIN
export interface ProFormAdminForm {
  form: ProFormForm;
  sharing: ProFormShare;
  sections: ProFormAdminSection[];
}

export interface ProFormShare {
  districtsSharedWith: ProFormShareItem[];
  districesExcludedFrom: ProFormShareItem[];
}

export interface ProFormShareItem {
  id: number;
  proform_form_id: number;
  district_id: number;
  is_shared: number;
  is_deleted: number;
}

export interface ProFormAdminSection {
  id: number;
  proform_form_id: number;
  title: string;
  description: string;
  sort_order: number;
  questions: ProFormAdminQuestion[];
}

export interface ProFormAdminQuestion {
  id: number;
  proform_form_id: number;
  field_type: string;
  question: string;
  helper_text: string;
  required: number;
  allow_other_answer: number;
  sort_order: number;
  is_deleted: number;
  field_type_specs: string;
  proform_form_section_id: number;
  answerOptions: ProFormQuestionAnswerOption[];
}

export interface ProFormQuestionAnswerOption {
  id: number;
  proform_form_id: number;
  proform_form_question_id: number;
  answer: string;
  is_correct: number;
  sort_order: number;
  is_deleted: number;
  next_section_override: string;
}

export enum ProformViewStates {
  PREVIEW = 'preview', // When previewing form; cannot submit
  EDIT = 'edit', // When user is filling out the form; can edit values and submit the form
  SUBMITTED = 'submitted', // When viewing a user's submitted form; cannot edit selected values
  GRADED = 'graded', // When viewing the graded form; cannot edit selected values
}
